import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import type { BidAwardRevokeReasonsCollection } from './bid-award-revoke-reasons.types';

export function bidAwardRevokeReasonsBackend(): Backend<BidAwardRevokeReasonsCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'buyer/getBidAwardRevokeReasons.php',
      isGaf: true,
      params: {},
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
